import { render, staticRenderFns } from "./yw_PerformanceStatistics_db.vue?vue&type=template&id=d2d941b8"
import script from "./yw_PerformanceStatistics_db.vue?vue&type=script&lang=js"
export * from "./yw_PerformanceStatistics_db.vue?vue&type=script&lang=js"
import style0 from "./yw_PerformanceStatistics_db.vue?vue&type=style&index=0&id=d2d941b8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports